const appConfig = {
  backOfficeUrl: 'https://backoffice.onceforall.com',
  maintenanceUrlJSON: 'https://platform.onceforall.com/maintenance/maintenance.json',

  discoverPanDaUrl: 'https://adherent.attestationlegale.fr/panda-demande-agrement',
  ssoPanDaURL: 'https://identity.onceforall.com/auth/realms/DA/protocol/openid-connect/auth?client_id=front-da&redirect_uri=https://plateforme.panda-agrement.fr&response_type=code&scope=openid&kc_idp_hint=keycloak-oidc',

  ssoVitrineURL: 'https://platform.references.onceforall.com',

  ssoBdrURL: 'https://artiopdnadb2c.b2clogin.com/artiopdnadb2c.onmicrosoft.com/b2c_1a_signup_signin/oauth2/v2.0/authorize?client_id=aa3adf0b-288e-48c9-8f41-35301a445301&redirect_uri=https%3A%2F%2Fportal.onceforall.com%2Fmarketplace&response_type=token%20id_token&scope=https%3A%2F%2Fartiopdnadb2c.onmicrosoft.com%2Fartiobackend%2Fuser_impersonation%20profile%20openid&response_mode=fragment&domain_hint=Hub&auth_origin=alg',

  projectApi: 'https://project.onceforall.com',
  organisationApi: 'https://organisation.onceforall.com',
  interventionApi: 'https://project.onceforall.com',
  documentTypeApi: 'https://ecm.onceforall.com',
  documentApi: 'https://ecm.onceforall.com',
  relationshipApi: 'https://relationship.onceforall.com',
  userApi: 'https://user.onceforall.com',
  enrollmentApi: 'https://enrollment.onceforall.com',
  subscriptionApi: 'https://subscription.onceforall.com',
  notificationApi: 'https://notification.onceforall.com',
  signatureApi: 'https://signature.onceforall.com',
  mandateApi: 'https://mandate.onceforall.com',
  reportingApi: 'https://reporting.onceforall.com',
  logoUrl: 'https://static.onceforall.com/logo/',

  keycloak: {
    url: 'https://identity.onceforall.com/auth',
    realm: 'OnceForAll',
    clientId: 'front-onceforall-mf'
  },

  sentry: {
    url: 'https://d8e09cfa7be245e393cb2dd54046357e@sentry.io/1387075',
    environment: 'production'
  },

  hotjar: {
    id: '2018198',
    version: 6
  },

  featureFlags: {
    inviteUser: false,
    noSubcontractorsDossierStateCalls: false, // /!\ For emergency only! Will disable call to ECM for subcontractors dossier states /!\
    showGlobalKPIs: true,
    showProjectKPIs: true,
    displayExpiredAndAlmostExpiredNotifications: false,
    invalidDocuments: true,
    reinviteNotDepositorInProject: false,
    newHelpCenter: false,
    relationshipDocuments: {
      clientDocuments: false
    },
    showAccessPandaButton: true,
    showAccessVitrineButton: true,
    showAccessBdrButton: true,
    showTBFAQ: true
  },

  offline: false,
  log: 'sentry',

  monitoring: {
    header: 'X-OnceForAll-TraceId',
    appId: 'OFAFO'
  },
  gtmId: 'GTM-WNTSBXG',
  analytics: 'G-VTK2ZKJT18',
  isMicrofront: true,
  // This has to be equal to microfront rooting regarding this microfront
  microfrontBasePath: '/alg'
};

module.exports = appConfig;
